import {css} from 'aphrodite';
import React from 'react';

import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import ProcedurePageLinkForProcedureRun from 'procedures/ProcedurePageLinkForProcedureRun';
import getProcedureReplicateNames from 'procedures/utils/getProcedureReplicateNames';
import getProcedureRunConditionNames from 'procedures/utils/getProcedureRunConditionNames';
import {UpdateTaskParams} from 'processes/process-task-details/utils/updateTaskDetailsTask';
import BenchChip from 'ui-library/chips/BenchChip';
import {ChipSize} from 'ui-library/chips/Chip';

import FormattedTextField from '../fields/FormattedTextField';
import PlaceholderFieldValue from '../fields/PlaceholderFieldValue';
import {
  getProcedureStepTaskDetailsSummaryRows,
  ProcedureMethodTaskField,
} from '../procedures/getProcedureStepTaskDetailsSections';
import {
  ProcessTaskDetailsRowContent,
  PROCESS_TASK_DETAILS_PAGE_STYLES,
  ProcessTaskGql,
  PROCESS_TASK_DETAILS_LABELS,
} from '../ProcessTaskDetailsPageConstants';

export function getAssayStepTaskDetailsSummaryRows(
  processTask: ProcessTaskGql,
  onUpdateTask: (updatedTask: UpdateTaskParams) => Promise<void>
): Array<ProcessTaskDetailsRowContent> {
  let methodExecutionInstance = null;
  let experimentRunTask = null;
  let conditionsDisplayString = null;
  let procedureRun = null;
  let replicateDisplayString = null;
  if (
    processTask.procedureStepExecutionInstance != null &&
    !isInaccessible(processTask.procedureStepExecutionInstance)
  ) {
    methodExecutionInstance = processTask.procedureStepExecutionInstance?.methodExecutionInstance;
  }
  if (methodExecutionInstance != null && !isInaccessible(methodExecutionInstance)) {
    experimentRunTask = methodExecutionInstance?.procedureRun.processFlowchartTask;
    conditionsDisplayString = getProcedureRunConditionNames(methodExecutionInstance);
  }
  if (methodExecutionInstance != null && !isInaccessible(methodExecutionInstance)) {
    procedureRun = methodExecutionInstance?.procedureRun;
    replicateDisplayString = getProcedureReplicateNames(methodExecutionInstance);
  }

  return getProcedureStepTaskDetailsSummaryRows(processTask, onUpdateTask, {
    experimentRunContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_EXPERIMENT_RUN,
      component:
        experimentRunTask != null ? (
          <BenchChip
            id={isInaccessible(experimentRunTask) ? null : experimentRunTask.id}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.chipHeight)}
            size={ChipSize.TABLE_CELL}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    unitOperationContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_UNIT_OPERATION,
      component: <ProcedureMethodTaskField processTask={processTask} />,
    },
    procedureTemplateContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_TEMPLATE,
      component:
        procedureRun != null ? (
          <ProcedurePageLinkForProcedureRun
            procedureRun={procedureRun}
            className={css(PROCESS_TASK_DETAILS_PAGE_STYLES.rowHeight)}
          />
        ) : (
          <PlaceholderFieldValue />
        ),
    },
    conditionsContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_CONDITIONS,
      component: conditionsDisplayString ? (
        <FormattedTextField text={conditionsDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
    replicatesContent: {
      label: PROCESS_TASK_DETAILS_LABELS.ASSAY_REPLICATE,
      component: replicateDisplayString ? (
        <FormattedTextField text={replicateDisplayString} />
      ) : (
        <PlaceholderFieldValue />
      ),
    },
  });
}
